/**
  The rgba() function helps you to create a rgba color code, it uses the hexToRgb(: any) function
  to convert the hex code into rgb for using it inside the rgba color format.
 */

import hexToRgb from "./hexToRgb";

function rgba(color:any, opacity: any) {
  return `rgba(${hexToRgb(color)}, ${opacity})`;
}

export default rgba;
